import { render, staticRenderFns } from "./ArtsUniversity.vue?vue&type=template&id=70257df0&scoped=true"
import script from "./ArtsUniversity.vue?vue&type=script&lang=js"
export * from "./ArtsUniversity.vue?vue&type=script&lang=js"
import style0 from "./ArtsUniversity.vue?vue&type=style&index=0&id=70257df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70257df0",
  null
  
)

export default component.exports